import React from 'react';
import { Route, IndexRoute } from 'react-router';

import HorseRacingMostFollowed from 'modules/HorseRacing/containers/HorseRacingMostFollowed';

import HorseRacingNextRaceOff from 'modules/Common/containers/HorseRacingNextRaceOff';
import RacingTips from 'modules/Common/containers/RacingTips';

import AdvertWrapper from 'modules/Common/components/AdvertWrapper';
import GooglePublisherTag from 'modules/Common/containers/GooglePublisherTag';

import InsiderBenefitsPage from './containers/InsiderBenefitsPage';
import InsiderBenefits from './containers/InsiderBenefits';

const HorseRacingSideBarComponentsNoTips = {
  GooglePublisherTag,
  HorseRacingNextRaceOff,
  AdvertWrapper
}

const HorseRacingSideBarComponents = {
  ...HorseRacingSideBarComponentsNoTips,
  RacingTips
}

const InsiderBenefitsPageComponents = {
  InsiderBenefits,
  HorseRacingMostFollowed,
  ...HorseRacingSideBarComponents
}

const InsiderRoutes = (

    <Route path="insider" components={InsiderBenefitsPage}>
        <IndexRoute components={InsiderBenefitsPageComponents}/> {/*Has Layout*/}
    </Route>
)

export default InsiderRoutes



// WEBPACK FOOTER //
// ./modules/Insider/routes.js